<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Fresh Leads">
      <v-card flat class="px-2"> </v-card>
      <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-chip> {{ selectedRow.length }} Rows Selected </v-chip>
          <v-spacer></v-spacer>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            @input="searchData"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />
          <v-btn
            :disabled="selectedRow.length < 1"
            elevation="1"
            @click="
              () => {
                modalOk = true
              }
            "
            :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="primary"
          >
            <v-icon left>mdi-account-check</v-icon>
            Assign
          </v-btn>
          <v-btn class="ml-4" :disabled="!(leadsData.length > 0)" @click="exportToCSV()" v-if="$vuetify.breakpoint.smAndUp" color="primary" elevation="1">
            <v-icon left>mdi-download</v-icon>
            Export All
          </v-btn>
        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table
          v-model="selectedRow"
          show-select
          :headers="headers"
          :items="leadsData"
          disable-pagination
          :hide-default-footer="true"
        >
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <v-col >
          <v-row>
            <v-col cols="4" sm="3">
              <v-select
                v-model="pageSize"
                :items="pageSizes"
                label="Items per Page"
                @change="handlePageSizeChange"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="10"
                @input="handlePageChange"
              ></v-pagination>
            </v-col>
          </v-row>
      </v-col>
      </v-card-component>
    </material-card>

    <v-dialog
      persistent
      v-model="modalOk"
      max-width="900"
      :active="modalOk"
      :on-cancel="
        () => {
          modalOk = false
          clearData()
        }
      "
    >
      <form @submit.prevent="saveAssignee">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Assign Agent</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(modalOk = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-autocomplete required label="Agent *" clearable v-model="agentID" :items="agentLits" key="id" item-value="id" item-text="fullName"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete label="Reason" clearable v-model="reason" :items="reasonList" item-value="name" item-text="name"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea :required="reason === 'Other'" rows="2" name="input-7-1" label="Comment" v-model.trim="comment"></v-textarea>
              </v-col>

              <v-col cols="12">
                <v-card-actions class="justify-space-between">
                  <v-chip> {{ selectedRow.length }} Rows Selected </v-chip>
                  <v-btn color="success" type="submit">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>

    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import { mapGetters } from 'vuex'
import ExportUtility from '@/utils/exportUtility'
import _ from 'lodash'
import moment from 'moment'
export default {
  components: { VCardComponent, MaterialCard },
  data () {
    return {
      isLoading: false,
      leadsData: [],
      search: '',
      headers: [
        { text: 'Enquiry Code', value: 'enquiryCode' },
        { text: 'Student name', value: 'studentFullName' },
        { text: 'Gender', value: 'gender' },
        { text: 'Father name', value: 'fatherName' },
        { text: 'Class', value: 'studentClass.name' },
        { text: 'Center Name', value: 'franchiseeName' },
        { text: 'Franchisee', value: 'franchisee.companyName' },
        { text: 'SPANCO status', value: 'spancoStatus' },
        { text: 'Enquiry Date', value: 'dateOfEnquiry' }
      ],
      reasonList: ['Sales Rep left for the day / Long Leave(Health/Personal/ Emergency issues)', 'Leads assigned to skilled sales rep for better conversion', 'Sales Rep Attrition', 'Other'],
      selectedRow: [],
      modalOk: false,
      agentLits: [],
      agentID: '',
      reason: '',
      comment: '',
      spancoDefaultStatus: '',
      spancoDefaultStage: '',
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20, 40]
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.academicYearChange()
    }
  },

  async created () {
    this.spancoDefaultStatus = CONSTANTS.SPANCOSTATUS.DEFAULT
    this.spancoDefaultStage = CONSTANTS.SPANCOSTATUS.DEFAULTSTAGE
    await this.onFranchiseeChange()
    await this.getLeads()
    await this.getAgents()
  },
  methods: {
    academicYearChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
        this.page = 1
        this.getLeads()
      }
    },
    saveAssignee: async function () {
      if (this.selectedRow.length < 1) {
        this.errMsg('Kindly select atleast one student!')
        return false
      }
      let formData = {
        enquiries: this.selectedRow,
        assignedToID: this.agentID,
        reason: this.reason,
        comment: this.comment
      }
      try {
        this.isLoading = true
        await http.post(`${CONSTANTS.API_URL}/api/enquiry/update/assignee`, formData)
        await this.getLeads()
        await this.getAgents()
        this.clearData()
        this.selectedRow = []
        this.modalOk = false
        this.okMsg('Leads assigned successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getAgents: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/enquiry/get-assignee`)
        this.agentLits = res.data
        this.agentLits = _.map(this.agentLits, a => {
          a.firstName = _.startCase(_.toLower(a.firstName))
          a.lastName = _.startCase(_.toLower(a.lastName))
          a.fullName = `${a.firstName} ${a.lastName} (${a.count})`
          return a
        })
        // console.log(this.agentLits)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getLeads: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/enquiry/get-fresh-leads?page=${this.page - 1}&size=${this.pageSize}&search=${this.search}&academicYearID=${this.academicYearID}`)
        console.log('res', res)
        this.leadsData = res.data.rows
        this.totalPages = res.data.totalPages
        this.leadsData = _.map(this.leadsData, a => {
          a.studentFullName = a.studentFirstName ? a.studentFirstName : '' + a.studentMiddleName ? a.studentMiddleName : '' + a.studentLastName ? a.studentLastName : ''
          a.dateOfEnquiry = a.dateOfEnquiry ? moment(a.dateOfEnquiry).format('DD-MM-YYYY') : ''
          a.franchiseeName = a.franchiseeName || '-'
          a.gender = a.gender || '-'
          a.spancoStatus = `${this.spancoDefaultStatus} - ${this.spancoDefaultStage}`
          if (a.studentClass) {
            a.studentClass.name = a.studentClass ? a.studentClass.name : '-'
          } else {
            a.studentClass = { name: '-' }
          }
          if (a.franchisee) {
            a.franchisee.companyName = a.franchisee ? a.franchisee.companyName : '-'
          } else {
            a.franchisee = { companyName: '-' }
          }
          return a
        })
        // console.log('this.leadsData', this.leadsData)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.getLeads()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getLeads()
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getLeads()
      } else { this.getLeads() }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    exportToCSV () {
      const csvData = []
      this.leadsData.forEach((t, index) => {
        csvData.push({
          SRNo: index + 1,
          EnquiryCode: t.enquiryCode,
          StudentName: `${t.studentFirstName} ${t.studentLastName ? t.studentLastName : ''}`,
          Gender: t.gender,
          FatherName: t.fatherName,
          FatherEmail: t.fatherEmailID,
          OptingClass: t.studentClass.name,
          FranchiseeName: t.franchiseeName ? t.franchiseeName : '',
          SpancoStatus: t.spancoStatus,
          DateOfEnquiry: t.dateOfEnquiry
        })
      })

      ExportUtility.convertToCsv(csvData, 'FreshLeads')
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    clearData () {
      this.agentID = ''
      this.reason = ''
      this.comment = ''
    }
  }
}
</script>

<style></style>
